<template>
  <div class="footer-widget mb-0">
    <h4 class="footer-widget__title">{{ contactWidgetData.widgetTitle }}</h4>
    <div class="footer-widget__content">
      <p class="address">{{ getSettings.address.value }}</p>
      <ul class="contact-details">
        <li>تلفن: {{ getSettings.phone.value }}</li>
        <li>ایمیل: {{ getSettings.contact_email.value }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
import { settingStore } from "@/store/Modules/setting.js"
import { mapState } from "pinia"
import { mapStores } from "pinia"
import { mapActions } from "pinia"
export default {
  props: ["contactWidgetData"],
  computed: {
    ...mapState(settingStore, ["getSettings"]),
  },
}
</script>
